import { render, staticRenderFns, recyclableRender, components } from "./exam.vue?vue&type=template&id=c1d233d2&scoped=true&"
var renderjs
import script from "./exam.vue?vue&type=script&lang=js&"
export * from "./exam.vue?vue&type=script&lang=js&"
import style0 from "./exam.vue?vue&type=style&index=0&id=c1d233d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d233d2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/tabBar/firstPage/exam.vue"
export default component.exports